<template>
  <div id="archive-users">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{ translations('account_setting.account_manage') }}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ translations('account_setting.user_list') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="form-group mr-2">
            <button v-if="isAdmin" class="btn btn-primary" type="button" @click="openSingleUser()">{{ translations('account_setting.add') }}</button>
          </div>
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <table id="tbl-users" class="table table-striped table-hover table-1500 table-clickable">
          <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
          <thead>
            <tr>
              <th>{{ translations('account_setting.username') }}</th>
              <th>{{ translations('account_setting.permission') }}</th>
              <th>{{ translations('account_setting.cost_download') }}</th>
              <th>{{ translations('account_setting.email_address') }}</th>
              <th>{{ translations('account_setting.department_classification') }}</th>
              <th>{{ translations('account_setting.employee_classification') }}</th>
              <th>{{ translations('account_setting.gender') }}</th>
              <th>{{ translations('account_setting.hire_date') }}</th>
              <th>{{ translations('account_setting.birthday') }}</th>
              <th>{{ translations('account_setting.remarks') }}</th>
            </tr>
          </thead>
          <tbody>
            <template>
              <tr v-for="(user, i) in users" :key='i' data-href="" @click="openSingleUser(user)">
                <td>{{ user.user_name }}</td>
                <td>{{ user.user_privilege }}</td>
                <td>
                  <span class="badge" :class="(Number(user.allow_cost_download) === 1) ? 'badge-danger' : ((Number(user.allow_cost_download) === 2) ? 'badge-success' : '')">
                    {{ (Number(user.allow_cost_download) === 1) ? translations('account_setting.pending') : ((Number(user.allow_cost_download) === 2) ? translations('account_setting.approved') : '') }}
                  </span>
                </td>
                <td>{{ user.email }}</td>
                <td>{{ user.user_division }}</td>
                <td>{{ user.user_position }}</td>
                <td>{{ getGenderLabel(user.gender) }}</td>
                <td>{{ $invoiceTools.formatDate(user.join_date) }}</td>
                <td>{{ $invoiceTools.formatDate(user.birthday) }}</td>
                <td>{{ user.memo }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveUsers',
  props: {},
  components: {
    VueElementLoading
  },
  watch: {
    dtSearch (v) {
      this.$storage.set('usersFilter', v)
      this.dt.search(v).draw()
      window.$('#tbl-users .dataTables_empty').text('該当する結果がありません')
    }
  },
  data () {
    return {
      dt: [],
      dtSearch: '',
      isLoading: true,
      isSearching: false,
      users: ''
    }
  },
  created: async function () {
    this.isLoading = true
    await this.getUsersList()
    await this.getInitData()

    this.dtSearch = this.$storage.get('usersFilter') || ''
    setTimeout(() => {
      this.repositionPagination()
      this.isLoading = false
    }, 1000)
  },
  mounted: function () {
    this.isLoading = true
  },
  computed: {
    ...mapState(['currentLanguage']),
    isAdmin: function () {
      return this.$store.getters['User/isAdmin']
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getGenderLabel (status) {
      if (Number(status) === 1) {
        return '男性'
      } else if (Number(status) === 2) {
        return '女性'
      }
      return 'その他'
    },
    getInitData () {
      this.dt = window.$('#tbl-users').DataTable({
        stateSave: true, // KEEP PAGE NUMBER
        order: [[1, 'desc']],
        language: {
          emptyTable: '該当する結果がありません'
        }
      })
      this.dt.draw(false) // KEEP PAGE NUMBER
    },

    repositionPagination () {
      window.$('#tbl-users_info').parent().remove()
      window.$('#tbl-users_wrapper > div:nth-child(1)').remove()
      window.$('div#tbl-users_paginate').parent().css({ position: 'absolute', 'margin-top': '18px', width: 'initial' })
    },
    async getUsersList () {
      let self = this

      try {
        let usersList = await this.$http.post(this.$api_url.account_user_list)
        let $data = self.$invoiceTools.prepareResult(usersList.data, 'list', 'ArchiveUsers:getUsersList')

        if ($data.success === true) {
          self.users = $data.data
        } else {
          self.users = []
        }
      } catch (error) {
        console.log('account:user_list:catch(error): ', error)
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    openSingleUser (user = null) {
      if (!this.isAdmin) {
        this.$toastr.warning('管理者のみ編集できます。')
        return
      }
      if (user) {
        this.$router.push({ name: 'single-users', query: { user_id: user.id } })
      } else {
        this.$router.push({ name: 'single-users' })
      }
    }
  }
}
</script>
